class Repository {
    constructor(endpoint) {
        this.endpoint = window.akita.urls.api + "/v1/playbooks";
    }

    remove(id, request) {
        return axios.delete(this.endpoint + "/" + id, request);
    }

    index(request) {
        return axios.get(this.endpoint, request);
    }

    show(id, request) {
        return axios.get(this.endpoint + "/" + id, request);
    }

    store(payload, request) {
        return axios.post(this.endpoint, payload, request);
    }

    update(id, payload, request) {
        return axios.put(this.endpoint + "/" + id, payload, request);
    }

    actions(playbookId) {
        return new (require("@/js/repositories/base.js"))(
            this.endpoint + "/" + playbookId + "/actions"
        );
    }

    triggers(playbookId) {
        return new (require("@/js/repositories/playbook-triggers.js"))(
            this.endpoint + "/" + playbookId + "/triggers"
        );
    }

    followers(playbookId) {
        return new (require("@/js/repositories/base.js"))(
            window.akita.urls.api + "/v1/playbooks/" + playbookId + "/followers"
        );
    }
}

module.exports = Repository;
